import { Loader2 } from 'lucide-react'
import { cn } from '../../lib/utils'

interface LoadingSpinnerProps {
  variant?: 'spinner'
  message?: string
  size?: 'sm' | 'md' | 'lg'
  className?: string
}

interface LoadingSkeletonProps {
  variant: 'skeleton'
  columns?: number
  rows?: number
  aspectRatio?: string
  className?: string
}

interface LoadingInlineProps {
  variant: 'inline'
  message?: string
  className?: string
}

export type LoadingStateProps = LoadingSpinnerProps | LoadingSkeletonProps | LoadingInlineProps

export const LoadingState = (props: LoadingStateProps) => {
  const { variant = 'spinner', className } = props

  if (variant === 'skeleton') {
    const { columns = 4, rows = 1, aspectRatio = 'aspect-square' } = props as LoadingSkeletonProps
    return (
      <div className={cn('grid gap-2', className)} style={{ gridTemplateColumns: `repeat(${columns}, minmax(0, 1fr))` }}>
        {Array.from({ length: columns * rows }).map((_, i) => (
          <div key={i} className={cn(aspectRatio, 'bg-gray-100 rounded-lg animate-pulse')} />
        ))}
      </div>
    )
  }

  if (variant === 'inline') {
    const { message } = props as LoadingInlineProps
    return (
      <span className={cn('inline-flex items-center gap-1.5 text-sm text-gray-500', className)}>
        <Loader2 size={14} className="animate-spin" />
        {message}
      </span>
    )
  }

  // Default: spinner
  const { message, size = 'md' } = props as LoadingSpinnerProps
  const sizeMap = { sm: 16, md: 24, lg: 36 }

  return (
    <div className={cn('flex flex-col items-center justify-center py-12', className)}>
      <Loader2 size={sizeMap[size]} className="animate-spin text-gray-400" />
      {message && <p className="mt-3 text-sm text-gray-500">{message}</p>}
    </div>
  )
}
